<div class="sb-grid-item--icon">
  <span class="sb-grid-item--icon-number color-muted" *ngIf="hasPosition">{{ position }}</span>
  <img class="sb-grid-item--icon-image" [src]="image" (error)="defaultErrorImage()" #imageRef />
</div>
<div class="sb-grid-item--teams">
  <p class="sb-grid-item--title color-dark">{{ title | sportsTitleCase }}</p>
  <p class="sb-grid-item--subtitle color-muted">{{ text }}</p>
</div>
